import { Injectable } from '@angular/core';
import { Participant } from '../../components/diagram-canvas/models/participant.class';
import { BASE_Y, GAP_BETWEEN_PARTICIPANTS, MARGIN_BOTTOM, MARGIN_LEFT } from '../../components/diagram-canvas/constants';
import { GAP_BETWEEN_MESSAGES, MARGIN_BEFORE_FIRST_ARROW } from '../../components/diagram-canvas/constants';

@Injectable({
  providedIn: 'root',
})
export class DiagramConfigurationService {
  optimiseCanvasWidth(participants: Participant[], canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D): void {
    const dynamicGap = this._calculateDynamicGap(participants, ctx);
    const requiredWidth = MARGIN_LEFT + participants.length * dynamicGap;
    const maxWidth = canvas.parentElement?.clientWidth ?? requiredWidth;

    canvas.width = Math.max(requiredWidth, maxWidth);
  }

  optimiseCanvasHeight(lines: string[], canvas: HTMLCanvasElement): void {
    const minHeight = BASE_Y + MARGIN_BEFORE_FIRST_ARROW + lines.length * GAP_BETWEEN_MESSAGES + MARGIN_BOTTOM;
    if (canvas.height < minHeight) {
      canvas.height = minHeight;
    }
  }

  extractParticipants(lines: string[]): Participant[] {
    const participants: Participant[] = [];

    for (const line of lines) {
      if (line.startsWith('actor ') || line.startsWith('entity ')) {
        participants.push(new Participant(line));
      }
    }
    return participants;
  }

  assignParticipantPositions(participants: Participant[], ctx: CanvasRenderingContext2D): void {
    const dynamicGap = this._calculateDynamicGap(participants, ctx);

    participants.forEach((participant, index) => {
      participant.x = MARGIN_LEFT + index * dynamicGap;
      participant.y = BASE_Y;
    });
  }

  parseEditorContent(text: string): string[] {
    return text
      .split('\n')
      .map(line => line.trim())
      .filter(Boolean);
  }

  private _calculateDynamicGap(participants: Participant[], ctx: CanvasRenderingContext2D): number {
    if (participants.length === 0) {
      return GAP_BETWEEN_PARTICIPANTS;
    }

    const maxBoxWidth = Math.max(
      ...participants.map(p => {
        const textWidth = ctx.measureText(p.name).width;
        return Math.max(100, textWidth + 20);
      })
    );

    return maxBoxWidth + 100;
  }
}
